import React from "react";
import AgeGradeHero from "./age-grades/AgeGradeHero";
import AgeGradeMeaning from "./age-grades/AgeGradeMeaning";
import AgeGradeList from "./age-grades/AgeGradeList";
import HowToJoin from "./age-grades/HowToJoin";
import FinalInvitation from "./age-grades/FinalInvitation";

const AgeGrades = () => {
  return (
    <main>
      <AgeGradeHero />
      <AgeGradeMeaning />
      <AgeGradeList />
      <HowToJoin />
      <FinalInvitation />
    </main>
  );
};

export default AgeGrades;
